


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import CourseService from './../../services/CourseService';

import getMonthYear from './../../ts/getMonthYear';
import getLightboxCode from './../../ts/getLightboxCode';
import highlightSearch from './../../ts/highlightSearch';
import noRecordsFound from './../../ts/noRecords';
import animateLogo from './../../ts/animateLogo';

@Component
export default class Course extends Vue {
  data = [];
  dataLoaded = false;
  error = '';
  query = this.$store.state.search;

  async created(): Promise<void> {
    try {
      this.data = await CourseService.getCourse();
      this.$store.commit('setRecords', this.data);
      this.dataLoaded = true;
      getLightboxCode();
      animateLogo('logo-image', '');
    } catch (err) {
      this.error = err.message;
    }
  }

  mounted(): void {
    animateLogo('logo-image', 'spin');
    this.updateMeta();
  }

  updateMeta(): void {
    const titleEl = document.querySelector('head title');
    if (titleEl) {
      titleEl.textContent = 'Courses and Awards | Chris Corchado';
    }

    const descEl = document.querySelector("[name='description']");
    if (descEl) {
      descEl.remove();
    }

    const desc = document.createElement('meta');
    desc.setAttribute('name', 'description');
    desc.setAttribute(
      'content',
      'Courses taken and awards received within the Information Technology field'
    );
    document.getElementsByTagName('head')[0].appendChild(desc);
  }

  // needed for the highlight search to work
  beforeUpdate(): void {
    this.query = this.$route.query.q;
  }

  updated(): void {
    if (this.data.length == 0) {
      noRecordsFound(
        'no-records',
        this.$store.state.search,
        'navigation',
        'No matches found for'
      );
    } else {
      noRecordsFound('no-records', '', 'navigation', 'No matches found for');
    }
  }

  getMonthYear = getMonthYear;

  highlightSearch = highlightSearch;

  @Watch('$route')
  async onPropertyChanged(value: unknown): Promise<void> {
    this.data = await CourseService.getCourse(
      // @ts-ignore
      value.query.page,
      this.$route.query.dir,
      this.$store.state.search
    );
    this.$store.commit('setRecords', this.data);
  }
}
